import { IFeature } from 'types'
import { FEATURE_NAME } from './Schedules.model'

export const SchedulesFeature: IFeature = {
  title: FEATURE_NAME,
}
